import { GraphSchema } from '@camelot/server';

export interface DayAvailability {
  id: string;
  dayOfWeek: number;
  startTime: string;
  endTime: string;
  functionId?: string;
  userId?: string;
}

export interface PlanningAvailability extends DayAvailability {}

export interface ModifyDayAvailabilitiesPayloadInput {
  functionId: string;
  userId?: string;
  dayAvailabilities: ModifyDayAvailabilityPayloadInput[];
}

export interface ModifyDayAvailabilityPayloadInput {
  id?: string | null;
  dayOfWeek: number;
  startTime: string;
  endTime: string;
}

export enum dayOfTheWeek {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 0,
}

export const dayAvailabilityProps = new GraphSchema<DayAvailability>([
  'id',
  'dayOfWeek',
  'startTime',
  'endTime',
  'functionId',
  'userId',
]);
